import { FaPlus } from "react-icons/fa";
import { AddMyAddress,AddressList } from "../../index";
import styles from "./myaddress.module.css";

import {
  Loader,
} from "../../../../components/shared/index";
import { useState } from "react";
import {
  useDeleteUserAddressMutation,
  useUserAddressListQuery,
} from "../../../../queries/useUserAddress";
import Swal from "sweetalert2";
import { ErrorFallback, ErrorQueryBoundary } from "../../../../components";
import toast from "react-hot-toast";

const MyAddress = () => {
  const [showForm, setShowForm] = useState(false);
  const [editAddress, setEditAddress] = useState(null);

  const {
    data: addressList = [],
    isPending,
  } = useUserAddressListQuery();

  const { mutate: deleteAddress } = useDeleteUserAddressMutation();

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You can't get it later!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAddress(id);
        toast.success("Address has been removed.")
      }
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftCol}>
        {!showForm && (
          <div
            className={styles.addCard}
            onClick={() => {
              setEditAddress(null);
              setShowForm(true);
            }}
          >
            <span className={styles.plus}>
              <FaPlus size={50} />
            </span>
            <p>Add Address</p>
          </div>
        )}

        {showForm && (
          <div className={styles.formWrapper}>
            <AddMyAddress
              mode={editAddress ? "edit" : "add"}
              initialData={editAddress}
              addressId={editAddress?.id}
              onClose={() => {
                setShowForm(false);
                setEditAddress(null);
              }}
            />
          </div>
        )}
      </div>

      <div className={styles.rightCol}>
        <ErrorQueryBoundary
          fallback={<Loader title="Loading user addresses.." />}
          errorFallback={<ErrorFallback />}
        >
          {isPending ? (
            <Loader title="Loading user addresses.." />
          ) : (
            <AddressList
              addressList={addressList}
              onDelete={handleDelete}
              onEdit={(item) => {
                setEditAddress(item);
                setShowForm(true);
              }}
            />
          )}
        </ErrorQueryBoundary>
      </div>
    </div>
  );
};

export default MyAddress;
